// extracted by mini-css-extract-plugin
export default {"tablesContainer":"TariffsPage_tablesContainer__BX2mC"};